/* eslint-disable func-names */
import { v4 as uuid } from "uuid";

export const htmlLinebreak = () =>
  function () {
    return <br />;
  };

export const htmlLink = ({
  href,
  target,
  tracking,
  trackEventName,
  trackEventProps,
}: $TSFixMe) =>
  function (...chunks: $TSFixMe[]) {
    return (
      <a
        href={href}
        rel="noopener noreferrer"
        target={target}
        onClick={(e) => {
          tracking?.trackEvent(trackEventName, {
            ...trackEventProps,
            url: { href },
          });

          e.stopPropagation();
        }}
      >
        {chunks}
      </a>
    );
  };

export const htmlParagraph = (prop = {}) =>
  function (...chunks: $TSFixMe[]) {
    return (
      <p key={uuid()} className={(prop as $TSFixMe).className}>
        {chunks}
      </p>
    );
  };
export const htmlSpan = (prop = {}) =>
  function (...chunks: $TSFixMe[]) {
    return (
      <span key={uuid()} className={(prop as $TSFixMe).className}>
        {chunks}
      </span>
    );
  };
export const htmlStrong = () =>
  function (...chunks: $TSFixMe[]) {
    return <strong key={uuid()}>{chunks}</strong>;
  };
export const htmlButton = (onClick: $TSFixMe, prop = {}) =>
  function (...chunks: $TSFixMe[]) {
    return (
      <button
        type="button"
        className={(prop as $TSFixMe).className}
        key={uuid()}
        onClick={onClick}
      >
        {chunks}
      </button>
    );
  };

export const htmlH1 = (prop = {}) =>
  function (...chunks: $TSFixMe[]) {
    return (
      <h1 key={uuid()} className={(prop as $TSFixMe).className}>
        {chunks}
      </h1>
    );
  };
export const htmlH2 = (prop = {}) =>
  function (...chunks: $TSFixMe[]) {
    return (
      <h2 key={uuid()} className={(prop as $TSFixMe).className}>
        {chunks}
      </h2>
    );
  };
export const htmlH3 = (prop = {}) =>
  function (...chunks: $TSFixMe[]) {
    return (
      <h3 key={uuid()} className={(prop as $TSFixMe).className}>
        {chunks}
      </h3>
    );
  };
export const htmlUl = (prop = {}) =>
  function (...chunks: $TSFixMe[]) {
    return (
      <ul key={uuid()} className={(prop as $TSFixMe).className}>
        {chunks}
      </ul>
    );
  };
export const htmlLi = (prop = {}) =>
  function (...chunks: $TSFixMe[]) {
    return (
      <li key={uuid()} className={(prop as $TSFixMe).className}>
        {chunks}
      </li>
    );
  };

export default {
  br: htmlLinebreak(),
  p: htmlParagraph(),
  span: htmlSpan(),
  strong: htmlStrong(),
  // @ts-expect-error TS(2554) FIXME: Expected 1-2 arguments, but got 0.
  button: htmlButton(),
  h1: htmlH1(),
  h2: htmlH2(),
  h3: htmlH3(),
  ul: htmlUl(),
  li: htmlLi(),
};
